import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from '@/components/common/Reveal';
import { industries } from '@/data/projects';
import { buttonVariants, Button } from '@/components/ui/button';

export const IndustriesSection = () => (
  <section id="industries" className="py-24 md:py-32 border-t border-border">
    <div className="mx-auto container-editorial">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
        <Reveal className="lg:col-span-7">
          <div className="label-eyebrow mb-4">Chapter — Industries</div>
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight text-balance">
            We specialise <span className="italic-serif text-sienna">where details are the deliverable.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-5 lg:pt-6">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Clinics live and die by trust — which lives in small things: a
            calm homepage, a legible fee list, a booking flow that respects a
            patient's time. That is the ground we build on.
          </p>
          <Link to="/industries" className={buttonVariants({ variant: 'ghost-editorial', className: 'mt-8' })}>
            Read the industry notes <ArrowUpRight className="w-4 h-4" />
          </Link>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mt-16">
        {industries.map((item) => (
            <div
                key={item.no}
                className="
        group
        rounded-3xl
        border border-sienna/15
        bg-secondary/20
        p-8
        min-h-[180px]
        transition-all duration-300
        hover:border-sienna/40
        hover:-translate-y-1
      "
            >
      <span className="label-eyebrow text-sienna">
        {item.no}
      </span>

              <div className="mt-8">
                <h3 className="font-serif text-3xl tracking-tight leading-none group-hover:text-sienna transition-colors">
                  {item.title}
                </h3>

                <p className="mt-3 text-base text-muted-foreground leading-relaxed">
                  {item.subtitle}
                </p>
              </div>
            </div>
        ))}
      </div>
      {/*<ul className="border-t border-border">*/}
      {/*  {industries.map((i, idx) => (*/}
      {/*    <motion.li*/}
      {/*      key={i.name}*/}
      {/*      initial={{ opacity: 0, y: 20 }}*/}
      {/*      whileInView={{ opacity: 1, y: 0 }}*/}
      {/*      viewport={{ once: true }}*/}
      {/*      transition={{ delay: 0.05 * idx, duration: 0.6 }}*/}
      {/*      className="group border-b border-border"*/}
      {/*    >*/}
      {/*      <div className="grid grid-cols-12 items-center gap-4 py-6 md:py-8 transition-colors group-hover:bg-secondary/40 -mx-5 md:-mx-10 px-5 md:px-10">*/}
      {/*        <span className="col-span-2 md:col-span-1 font-mono text-xs text-muted-foreground rule-numeric">*/}
      {/*          {String(idx + 1).padStart(2, '0')}*/}
      {/*        </span>*/}
      {/*        <span className="col-span-6 md:col-span-4 font-serif text-2xl md:text-4xl tracking-tight">*/}
      {/*          {i.name}*/}
      {/*        </span>*/}
      {/*        <span className="col-span-4 md:col-span-5 text-sm md:text-base italic-serif text-muted-foreground">*/}
      {/*          {i.note}*/}
      {/*        </span>*/}
      {/*        <span className="hidden md:inline col-span-2 text-right font-mono text-xs text-muted-foreground">*/}
      {/*          {i.count} project{i.count > 1 ? 's' : ''}*/}
      {/*        </span>*/}
      {/*      </div>*/}
      {/*    </motion.li>*/}
      {/*  ))}*/}
      {/*</ul>*/}
    </div>
  </section>
);

export default IndustriesSection;
